import React from 'react';
import withErrorCatcher from '../../../components/Common/withErrorCatcher.js'
import { push } from 'react-router-redux';
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import AppContent from '@components/App/appContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PageContentWrapper from '@components/App/PageComponents/pageContentWrapper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import AdminSettingsDrawer from '../../../components/App/Drawers/adminSettingsDrawer';
import AdminSettingsTitle from '../Common/AdminSettingsTitle.js';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  progress: {
    margin: `0 ${theme.spacing.unit * 2}px`,
    textAlign: 'center',
    align: 'center'
  },
  spinner: {
    textAlign: 'center',
    paddingTop: 16
  },
  paper: {
    padding: 16
  },
  paperStyle: {
    marginBottom: 40
  },
  listStyle: {
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    margin: 16
  }
})

export class Logs extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: 'a',
      scores: [],
      storageUse: 0,
      docsCount: 0,
      isLoading: true,
      activity: [],
      sources: [],
      logs: [],
      searched: [],
      archives: []
    }

  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this.props.queryService.getLogItems().then((archives) => {
      this.setState({
        archives: archives.archives,
        logs: archives.logs,//.filter(l => l.value.actionType != 'search'),
        searched: archives.searched,//logs.filter(l => l.value.actionType == 'search'),
        isLoading: false
      })
    })
  }

  render() {
    const { classes ,t} = this.props;
    const { archives, logs, isLoading, searched } = this.state;

    let spinner = null
    let archivesContent = null;
    let logsContent = null;
    let searchedContent = null;

    if (isLoading) {
      spinner = <div data-intrcm-id="logs_90lt2e37" className={classes.spinner}>
        <CircularProgress className={classes.progress} />
      </div>
    }
    else {
      if (archives.length) {
        archivesContent = <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>{t('Title')}</TableCell>
              <TableCell>{t('User')}</TableCell>
              <TableCell>{t('Update date')}</TableCell>
              <TableCell>{t('Type')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {archives.map(archive => {
              return (
                <TableRow key={archive.id}>
                  <TableCell component="th" scope="row"> {archive.value.document.title} </TableCell>
                  <TableCell>{archive.value.userName}</TableCell>
                  <TableCell numeric>{new Date(archive.value.dateTime).toLocaleString()}</TableCell>
                  <TableCell>{archive.value.type}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      }
      if (logs.length) {
        logsContent = <Paper className={classes.paperStyle}><Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>{t('Item Id')}</TableCell>
              <TableCell>{t('Item Title')}</TableCell>
              <TableCell>{t('User')}</TableCell>
              <TableCell>{t('Date')}</TableCell>
              <TableCell>{t('Type')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map(archive => {
              return (
                <TableRow key={archive.id}>
                  <TableCell  alt={archive.value.itemId} title={archive.value.itemId } component="th" scope="row"> {(archive.value.itemId || "").substring(0, 20)} </TableCell>
                  <TableCell alt={archive.value.itemTitle} title={archive.value.itemTitle }>{(archive.value.itemTitle || "").substring(0, 20)}</TableCell>

                  <TableCell>{archive.value.userName || archive.value.userID || archive.value.performer || ''}</TableCell>
                  <TableCell>{new Date(archive.value.dateTime).toLocaleString()}</TableCell>
                  <TableCell>{archive.value.actionType + ' ' + archive.value.subject }</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table></Paper>
      }
      if (searched.length) {
        searchedContent = <Paper className={classes.paperStyle}><Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>{t('Search Text')}</TableCell>
              <TableCell>{t('User')}</TableCell>
              <TableCell>{t('Date')}</TableCell>
              <TableCell>{t('Search Type')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {searched.map(archive => {
              return (
                <TableRow key={archive.id}>
                  <TableCell alt={archive.value.itemTitle} title={archive.value.itemTitle } >{(archive.value.itemTitle || "").substring(0, 20)}</TableCell>
                  <TableCell>{archive.value.userName || archive.value.userID || archive.value.performer}</TableCell>
                  <TableCell >{new Date(archive.value.dateTime).toLocaleString()}</TableCell>
                  <TableCell>{archive.value.subject}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table></Paper>
      }
    }

    return <AppContent >
      <PageContentWrapper drawer={<AdminSettingsDrawer selected="logs" />}>
        <Grid spacing={16}>
        <AdminSettingsTitle text={t('Archives')} />
          <Paper className={classes.paperStyle}>
            {spinner}
            {archivesContent}
          </Paper>

          {
            searchedContent ? <Typography variant="title" style={{ marginBottom: '15px' }}> {t('Searched')} </Typography> : null
          }
          {searchedContent}
          {
            logsContent ? <Typography variant="title" style={{ marginBottom: '15px' }}> {t('Logs')} </Typography> : null
          }
          {logsContent}

        </Grid>
      </PageContentWrapper>
    </AppContent>;
  }
}
const mapStateToProps = (state) => ({
  ...state.services,
  templates: state.globalData.templates

})

const mapDispatchToProps = dispatch => {
  return {
    goTo: path => { dispatch(push(path)) },

    dispatch: dispatch
  }
}

export default compose(withStyles(styles),
withTranslation('admin'),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ))(Logs);